import type { LicenseState } from './_state.type';

/** License State. */
export const licenseState: LicenseState = {
  license: {
    isActivated: false,
  },
};
